import { render, staticRenderFns } from "./DialogMonshinnaiyou.vue?vue&type=template&id=2cb3718f&scoped=true"
import script from "./DialogMonshinnaiyou.vue?vue&type=script&lang=js"
export * from "./DialogMonshinnaiyou.vue?vue&type=script&lang=js"
import style0 from "./DialogMonshinnaiyou.vue?vue&type=style&index=0&id=2cb3718f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb3718f",
  null
  
)

export default component.exports